import { AnanseApiService } from "app/services";
import useAPIErrorHandler from "./useAPIErrorHandler";

const useMiniScent = () => {
  const api = new AnanseApiService();
  const {
    loading,
    error,
    clearError,
    handleRequest,
  } = useAPIErrorHandler();

  //Busca dispositivo pelo serial number
  const searchDeviceBySerialNumber = async (serialNumber: string) => {
    return handleRequest(async () => {
      const data = await api.makeHttpRequest({
        method: "GET",
        url: `/miniscent/devices/${serialNumber}`,
      });
      return data;
    });
  };

  // Obtém estatísticas de uso por dispositivo
  const getStatusByDevice = async (serialNumber: string) => {
    return handleRequest(async () => {
      const data = await api.makeHttpRequest({
        method: "GET",
        url: `/miniscent/devices/${serialNumber}/stats`,
      });
      return data;
    });
  };

  // Lista todos os cartuchos MiniScent (com paginação)
  const listAllCatrigesByUser = async (userId: number) => {
    return handleRequest(async () => {
      const data = await api.makeHttpRequest({
        method: "GET",
        url: `/miniscent/cartridges`,
        params: { UserId: userId },
      });
      return data;
    });
  };
  // Lista todo o histórico de disparos (com paginação)
  const listAllShootingHistory = async (userId: number) => {
    return handleRequest(async () => {
      const data = await api.makeHttpRequest({
        method: "GET",
        url: `/miniscent/shots`,
        params: { UserId: userId },
      });
      return data;
    });
  };

  return {
    error,
    loading,
    clearError,
    searchDeviceBySerialNumber,
    getStatusByDevice,
    listAllCatrigesByUser,
    listAllShootingHistory,
  };
};

export default useMiniScent;
